import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { PALETTES } from "../classroomColors";
import { STANDE } from "../standeTokens";

/**
 * The panel a tool opens beside the bar (Figma 205:396, 205:399): a white
 * card with a labelled tab above it and a pointer back to the bar. It opens
 * to the left, because the bar is pinned to the right edge of the room.
 *
 * Both pickers are the same object with different contents, so the shell
 * lives here and they only supply children.
 */
const Flyout = ({ label, isOpen, isDark = false, children, top = 0, side = "left" }) => {
  if (!isOpen) return null;
  const p = isDark ? PALETTES.dark : PALETTES.light;

  return (
    <Box
      position="absolute"
      // Opens toward the room: a bar against the right edge opens left, one
      // against the left edge opens right. Hardcoding one way put the panel
      // off screen whenever the bar was docked on the other side.
      {...(side === "left" ? { right: "calc(100% + 14px)" } : { left: "calc(100% + 14px)" })}
      top={`${top}px`}
      zIndex={20}
      // A column aligned to the bar side, so the tab sits over the end of the
      // card nearest the tool it belongs to. Floating it instead pulled the
      // card out of shape.
      display="flex"
      flexDirection="column"
      alignItems={side === "left" ? "flex-end" : "flex-start"}
      sx={{ animation: "standeFlyIn 0.14s ease-out" }}
    >
      <Text
        display="block"
        px="9px"
        py="1px"
        mb="6px"
        borderRadius="8px"
        bg={STANDE.primaryBlue}
        color={STANDE.black}
        fontSize="11px"
        fontWeight="500"
        lineHeight="16px"
      >
        {label}
      </Text>

      <Box position="relative">
        {/* the pointer, on the bar side */}
        <Box
          position="absolute"
          {...(side === "left" ? { right: "-6px" } : { left: "-6px" })}
          top="22px"
          boxSize="12px"
          transform="rotate(45deg)"
          bg={p.surface}
          {...(side === "left"
            ? { borderRight: "1px solid", borderTop: "1px solid" }
            : { borderLeft: "1px solid", borderBottom: "1px solid" })}
          borderColor={p.border}
        />
        <Flex
          align="center"
          gap="8px"
          p="14px"
          borderRadius="14px"
          bg={p.surface}
          border="1px solid"
          borderColor={p.border}
          boxShadow="0 10px 28px -12px rgba(0,0,0,0.30)"
        >
          {children}
        </Flex>
      </Box>
    </Box>
  );
};

export default Flyout;
